/*
 *  Copyright 2019, 2020, 2021, 2022 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

export const GET_SOLD_OM_DATA = 'GET_SOLD_OM_DATA';
export const SET_SOLD_OM_DATA = 'SET_SOLD_OM_DATA';

export const GET_LABOUR_HAPPINESS_DATA = 'GET_LABOUR_HAPPINESS_DATA';
export const SET_LABOUR_HAPPINESS_DATA = 'SET_LABOUR_HAPPINESS_DATA';

export const GET_BIODIVERSITY_DATA = 'GET_BIODIVERSITY_DATA';
export const SET_BIODIVERSITY_DATA = 'SET_BIODIVERSITY_DATA';
export const GET_BIODIVERSITY_LOADING = 'GET_BIODIVERSITY_LOADING';
export const SET_BIODIVERSITY_LOADING = 'SET_BIODIVERSITY_LOADING';
export const GET_BIODIVERSITY_ERROR = 'GET_BIODIVERSITY_ERROR';
export const SET_BIODIVERSITY_ERROR = 'SET_BIODIVERSITY_ERROR';

export const GET_PRICES_DATA = 'GET_PRICES_DATA';
export const GET_PRICES_WITH_DISTANCE_DATA = 'GET_PRICES_WITH_DISTANCE_DATA';
export const SET_PRICES_DATA = 'SET_PRICES_DATA';

export const SET_PRICES_DISTANCE = 'SET_PRICES_DISTANCE';
